export const KeyboardListener = {
  mounted() {
    // Store bound functions as properties so we can reference them in 'destroyed()'
    this.boundOnKeydown = this.onKeydown.bind(this)
    this.boundOnKeyup = this.onKeyup.bind(this)

    document.addEventListener('keydown', this.boundOnKeydown)
    document.addEventListener('keyup', this.boundOnKeyup)
  },

  destroyed() {
    document.removeEventListener('keydown', this.boundOnKeydown)
    document.removeEventListener('keyup', this.boundOnKeyup)
  },

  onKeydown(event) {
    if (isInputElement(document.activeElement)) {
      return;
    }

    if (interestedInPressedKey(this, event)) {
      pushEventIfDefined(this, "keyboardListenerOnKeydown", event)
    }
  },

  onKeyup(event) {
    if (isInputElement(document.activeElement) && event.key != 'Escape') {
      return;
    }

    if (interestedInPressedKey(this, event)) {
      pushEventIfDefined(this, "keyboardListenerOnKeyup", event)
    }
  }
};

function extractEventDetails(event) {
  return {
    key: event.key,
    altKey: event.altKey,
    ctrlKey: event.ctrlKey,
    shiftKey: event.shiftKey,
    code: event.code,
  }
}

function isInputElement(element) {
  return element != null && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement);
}

function pushEventIfDefined(host, eventName, event) {
  const eventDetails = extractEventDetails(event)

  const eventToPush = host.el.dataset[eventName]
  if (eventToPush) {
    host.pushEvent(eventToPush, eventDetails)
  }
}

function interestedInPressedKey(host, event) {
  const codes = host.el.dataset["keyboardListenerCodeFilter"]

  if (!codes) {
    return true;
  }

  return codes.includes(event.code)
}
